export default __webpack_public_path__ + "static/media/llave_en_mano.76e6ba0b.png";